export const status_response = {
  success: 1,
  error: 0,
  not_register: -1
};

export const NOTIFY_CATEGORY = {
  ORDER: 1,
  PRODUCT_REVIEWS: 2,
  QA: 3,
  AFFILIATE: 4
};

export const NOTIFY_TYPE = {
  CUSTOMER: 1,
  SHOP: 2,
  PRODUCT_REVIEWS: 3
};

export const NOTIFY_CONTENT_TYPE = {
  CONFIRMED: 1,
  PAID: 2,
  SHIPPED: 3,
  RECEIVED: 4
};

export const role = {
  USER: 'user',
  SHOP: 'shop'
};
